// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__XNyYF","icon":"tag_icon__Tz03f"};